import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import qs from "qs";

import {
  getStrategyDashboardChartMarketTableFilters,
  resolveStrategyDashboardChartMarket,
  STRATEGY_DASHBOARD_CHART_MARKET_QUERY_PARAM
} from "../lib/StrategyDashboard/strategyDashboardChartMarkets";

/**
 * Reads chart market from the URL query for initial/deep-link seeding only.
 * Manual picker changes must not write back to the URL.
 */
export default function useStrategyDashboardChartMarketFromUrl(markets) {
  const location = useLocation();

  const query = useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  );

  const marketFromUrl = query[STRATEGY_DASHBOARD_CHART_MARKET_QUERY_PARAM];

  const selectedMarket = useMemo(
    () => resolveStrategyDashboardChartMarket(markets, marketFromUrl),
    [markets, marketFromUrl]
  );

  const tableMarketFilters = useMemo(
    () => getStrategyDashboardChartMarketTableFilters(markets, marketFromUrl),
    [markets, marketFromUrl]
  );

  return {
    selectedMarket,
    tableMarketFilters
  };
}
